<template>
  <div>
    <h2 class="ml-2 hedderLogin" id="getting-started">
      <a href="#getting-started" class="header-anchor">Reset</a> Password
    </h2>
   <br>
    <form class="container ml-2 mt-1 was-validatedd" style="width: 100%">
      <h6>
        <vs-row>
          <label class="fontSizeData">Verification Code</label>
          <vs-spacer />
        </vs-row>
        <input
          class="inputForm"
          @click="temppassword"
          v-model="passwordOld"
          placeholder="Enter Verification Code"
          type="password"
        />
      </h6>
      <h6 class="mb-4 mt-4">
        <vs-row>
          <label class="fontSizeData">New Password</label><vs-spacer />
          <span>
            <vs-icon
              style="cursor: pointer"
              @click="x = !x"
              icon="visibility"
            ></vs-icon>
          </span>
        </vs-row>
        <input
          v-if="x == false"
          placeholder="Enter Password"
          class="inputForm"
          id="password"
          type="password"
          @input="password_check"
          v-model="passwordValue"
        />
        <input
          v-if="x == true"
          placeholder="Enter Password"
          class="inputForm"
          id="password"
          type="text"
          @input="password_check"
          v-model="passwordValue"
        />
        <password-meter
          class="mb-2"
          style="background-color: #fdd244"
          v-if="passtrue == 3"
        />
        <password-meter
          class="mb-2"
          style="background-color: #35cc62"
          v-if="passtrue == true"
        />
        <password-meter
          class="mb-2"
          style="background-color: #f95e68"
          v-if="passtrue == false"
        />

        <h6 v-if="passwordValue!=null" class="ml-1">
          <ui>
            <li
              class="frmValidation text-danger"
              :class="{ 'frmValidation--passed': lenpass }"
            >
              At least 8 characters long
            </li>
            <li
              class="frmValidation text-danger"
              :class="{ 'frmValidation--passed': has_uppercase }"
            >
              At least one capital letter
            </li>
            <li
              class="frmValidation text-danger"
              :class="{ 'frmValidation--passed': has_number }"
            >
              At least one number
            </li>
          </ui>
        </h6>
      </h6>

      <h6 class="mb-1">
        <label class="fontSizeData">Confirm New Password</label>
        <input
          class="inputForm"
          v-model="usernameconfirm"
          placeholder="Enter Password"
          type="password"
        />
      </h6>
      <div v-if="passwordValue != null ">
      <span
        class="frmValidation text-danger"
        v-if="passwordValue != usernameconfirm "
      >
        Password doesn't match</span
      >
      <span
        class="frmValidation colorSuccess"
        v-if="passwordValue == usernameconfirm"
      >
        Password match</span
      ></div>
    </form>
    <br /><br />
    <vs-row>
      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
        <vs-button
          color="success"
          @click="acceptbtn"
          class="container-fluid"
          type="border"
          style="width: 65%; border-radius: 20px"
          ><h4>Submit</h4>
        </vs-button>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import passwordMeter from "vue-simple-password-meter";
export default {
  name: "Resetpassword",
  components: { passwordMeter },
  data: () => ({
    passwordValue: null,
    passwordOld: null,
    usernameconfirm: null,
    lenpass: false,
    has_number: false,
    has_lowercase: false,
    has_uppercase: false,
    has_special: false,
    passtrue: false,
    link: "",
    x: false,
    statuspass: false,
  }),
  methods: {
      temppassword(){
        // console.log('cdhci')
        
      },
      acceptbtn(){
        var body = {
            column: "*",
            secret: this.passwordOld,
            newpassword: this.passwordValue
        };
        this.$API.post('resetpassword/'+this.passwordOld,body,{
        headers: {
                  'Access-Control-Request-Method': '*',
                  'Access-Control-Request-Headers': '*',
                  'Access-Control-Allow-Origin': '*'
                },
        username: "admin",
        password: "admin",
        role: this.checkbox
        }).then((result)=>{
            if(result.status == 200){
                this.statuspass = true
                // console.log("Password Updated")
                 this.$vs.notify({title:'Password Updated',text:'Your password has been updated successfully',color: 'primary',position:'top-center'})
                 this.$router.push('/login')
                 
            }
            else if(result.status == 404){
                // console.log("Invalid Secret Code")
                 this.$vs.notify({title:'Invalid',text:'Please try again',color: 'warning',position:'top-center'})
            }
            else if(result.status == 500){
                this.statuspass = false
                // console.log("Link has expired")
                 this.$vs.notify({title:'Link has expired',text:'Your password reset link has expired.',color: 'warning',position:'top-center'})
            }
            else{
                // console.log("Not found")
            }
        })
        .then((result) => {
          if (result.status == 200) {
            this.statuspass = true;
            // console.log("Password Updated")
            this.$vs.notify({
              title: "Password Updated",
              text: "Your password has been updated successfully",
              color: "primary",
              position: "top-center",
            });
            this.$router.push("/login");
          } else if (result.status == 404) {
            // console.log("Invalid Secret Code")
            this.$vs.notify({
              title: "Invalid",
              text: "Please try again",
              color: "warning",
              position: "top-center",
            });
          } else if (result.status == 500) {
            this.statuspass = false;
            // console.log("Link has expired")
            this.$vs.notify({
              title: "Link has expired",
              text: "Your password reset link has expired.",
              color: "warning",
              position: "top-center",
            });
          } else {
            // console.log("Not found")
          }
        });
    },

    password_check: function () {
      this.lenpass = this.passwordValue.length > 8;
      this.has_number = /\d/.test(this.passwordValue);
      this.has_lowercase = /[a-z]/.test(this.passwordValue);
      this.has_uppercase = /[A-Z]/.test(this.passwordValue);
      if (
        this.passwordValue.length == 8 &&
        this.has_uppercase &&
        this.has_number
      ) {
        this.passtrue = true;
        this.$vs.notify({
          title: "Password meets requirements",
          color: "primary",
          position: "top-center",
        });
      } else if (this.has_uppercase) {
        this.passtrue = 3;
      } else if (this.passwordValue.length > 8) {
        this.passtrue = 3;
      } else if (this.has_number) {
        this.passtrue = 3;
      } else {
        this.passtrue = false;
      }
    },
  },
};
</script>

<style scoped>
.default-input {
  display: flex;
  align-items: flex-end;
  position: relative;
  background-color: #f95e68;
}
.po-password-strength-bar.risky {
  background-color: #f95e68;
}

.po-password-strength-bar.guessable {
  background-color: #f95e68;
}

.po-password-strength-bar.weak {
  background-color: #f95e68;
}

.po-password-strength-bar.safe {
  background-color: #f95e68;
}

.po-password-strength-bar.secure {
  background-color: yellow;
}
.frmField {
  background-color: white;
  color: #495057;
  line-height: 1.25;
  font-size: 16px;
  font-family: "Roboto", sans-serif;
  border: 0;
  padding: 10px;
  border: 1px solid #dbdbdb;
  border-radius: 3px;
  width: 90%;
}

.frmLabel {
  display: block;
  margin-bottom: 10px;
  font-weight: bold;
}
.frmValidation {
  font-size: 0.75rem;
}
.frmValidation--passed {
  display: none;
}
.frmIcon {
  color: #eb0029;
}
.frmValidation--passed .frmIcon {
  color: #0fa140;
}

.howToBuild {
  text-align: center;
  color: purple;
}
.howToBuild a {
  color: red;
  font-weight: bold;
  text-decoration: none;
  text-transform: uppercase;
}
</style>